<!--
 * @Author: natsu
 * @Date: 2020-09-02 16:51:59
 * @LastEditors: natsu
 * @LastEditTime: 2021-09-09 16:13:09
 * @Description: file content
-->
<template>
    <div class="wrapper">
      <header class="bg">
        <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
        <h2>UED-CDN</h2>
        <div class="logo-page"><img src="../assets/images/vue.png" /></div>
        <p>Vue3</p>
      </header>
      <section>
        <file-list :fileList="fileList"></file-list>
      </section>
    </div>
  </template>

<script>
const ur = "https://uedcdn.zto.com/static/vue3/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "3.4.38",
          linkList: [
            ur + "3.4.38/vue.global.js",
            ur + "3.4.38/vue.global.min.js",
            ur + "3.4.38/vue.global.prod.js",
            ur + "3.4.38/vue.esm-browser.js",
            ur + "3.4.38/vue.esm-browser.prod.js",
            ur + "3.4.38/vue.esm-bundler.js"
          ]
        },
        {
          label: "3.3.4",
          linkList: [
            ur + "3.3.4/vue.global.js",
            ur + "3.3.4/vue.global.prod.js",
            ur + "3.3.4/vue.esm-browser.js",
            ur + "3.3.4/vue.esm-browser.prod.js",
            ur + "3.3.4/vue.esm-bundler.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVue3.vue